import gsap from "gsap";

export default function Marquee() {
  Alpine.data("marquee", () => ({
    open: false,
    _marqueeTween: null,
    _resizeHandler: null,
    init() {
      const el = this.$el;
      const logos = Array.from(el.children);

      // Duplicate logos 3 times for seamless looping
      for (let i = 0; i < 4; i++) {
        logos.forEach((logo) => {
          const clone = logo.cloneNode(true);
          el.appendChild(clone);
        });
      }

      const animate = () => {
        // Kill previous tween if exists
        if (this._marqueeTween) this._marqueeTween.kill();

        // Get total width of all logos
        const totalWidth = Array.from(el.children).reduce(
          (acc, child) => acc + child.offsetWidth,
          0,
        );

        // Set speed in pixels per second
        const speed = 90; // adjust as needed

        // Calculate duration based on totalWidth and speed
        const duration = totalWidth / 2 / speed;

        // Animate marquee
        this._marqueeTween = gsap.to(el, {
          x: -totalWidth / 2,
          duration: duration,
          ease: "none",
          repeat: -1,
          modifiers: {
            x: gsap.utils.unitize((x) => parseFloat(x) % (totalWidth / 2)),
          },
        });
      };

      // Initial animation
      animate();

      // Recalculate on resize
      this._resizeHandler = () => {
        gsap.set(el, { x: 0 });
        animate();
      };
      window.addEventListener("resize", this._resizeHandler);

      // Clean up on Alpine component destroy
      this.$watch("open", (val) => {
        if (!val && this._marqueeTween) {
          this._marqueeTween.kill();
          this._marqueeTween = null;
        }
      });
      this.$el._cleanupMarquee = () => {
        if (this._marqueeTween) this._marqueeTween.kill();
        window.removeEventListener("resize", this._resizeHandler);
      };
    },
    destroy() {
      if (this._marqueeTween) this._marqueeTween.kill();
      window.removeEventListener("resize", this._resizeHandler);
    },
  }));
}
